const copy = {
  label: "Phone number",
  placeholder: "Enter your phone number",
  actions: {
    cancel: "Cancel",
    submit: "Submit",
  },
  errors: {
    invalidPhone: "Please enter a valid phone number",
  },
};
export default copy;
